// @flow
import * as React from 'react';
import type { MyBoardsTypeaheadProviderProps } from 'app/common/react/components/MyBoardsTypeaheadProvider/types';
import { filterItemsByQuery } from 'app/common/react/components/RepinPicker/utils/query';
import { SEARCH_FIELD_QUERY_LENGTH_MIN } from 'app/common/react/components/RepinPicker/RepinPicker';

const searchIsDisabledForQuery = (query: string) => query.length < SEARCH_FIELD_QUERY_LENGTH_MIN;

type State = {|
  query: string,
|};

export default class NonPaginatedMyBoardsTypeaheadProvider<T> extends React.PureComponent<
  MyBoardsTypeaheadProviderProps<T>,
  State,
> {
  state = { query: '' };

  handleQueryChange = (query: string) => this.setState({ query });

  render() {
    const { allBoardsResource, children } = this.props;
    const { query } = this.state;
    const isSearch = !searchIsDisabledForQuery(query);
    if (!allBoardsResource.isLoaded || !allBoardsResource.data) {
      return children({ isLoaded: false });
    }
    const fetchedBoards = Array.isArray(allBoardsResource.data)
      ? allBoardsResource.data
      : allBoardsResource.data.all_boards;
    return children({
      isLoaded: true,
      results: isSearch ? filterItemsByQuery(fetchedBoards, query) : fetchedBoards,
      fetchMore: undefined,
      isSearch,
      onQueryChange: this.handleQueryChange,
      query,
    });
  }
}
